module.exports = __webpack_public_path__ + "img/ape-constructor-arrow-right.88d84f2d.svg";